import styled from '@emotion/styled'
import { Product } from '@news-mono/web-common'
import { IconPremium } from '../../../icons'
import { breakpoint, calcRem, fonts, themedValue } from '../../../__styling'

export const StyledEpaperCollectionPaperMainContainer = styled('div')(
    ({ theme }) => ({
        display: 'flex',
        overflowX: 'scroll',
        gap: calcRem(8),
        justifyContent: 'flex-start',
        [breakpoint(theme.kind === Product.TheWest ? 'lg' : 'md')]: {
            display: 'flex',
            flexWrap: 'wrap',
            overflowX: 'visible',
        },
    }),
)

export const StyledEpaperCollectionPaperContainer = styled('div')(
    ({ theme }) => ({
        [breakpoint(theme.kind === Product.TheWest ? 'lg' : 'md')]: {
            flex:
                theme.kind === Product.TheWest
                    ? `0 1 ${calcRem(167)}`
                    : `0 1 133px`,
        },
    }),
)

export const StyledLatestEditionContainer = styled('div')(({ theme }) => ({}))

export const StyledEpaperCollectionPaperWrapper = styled('div')(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'flex-start',
        paddingBottom: calcRem(14),
        [breakpoint(theme.kind === Product.TheWest ? 'lg' : 'md')]: {
            display: 'flex',
            alignItems: 'start',
            marginTop:
                theme.kind === Product.TheWest ? calcRem(-3) : calcRem(-4),
            paddingBottom:
                theme.kind === Product.TheWest ? calcRem(16) : calcRem(12),
        },
    }),
)

export const StyledEpaperCollectionPaperSpanText = styled('text')(
    ({ theme }) => ({
        fontSize: calcRem(20),
        fontFamily: fonts.designSystem.sansSerif,
        fontWeight: 500,

        [breakpoint(theme.kind === Product.TheWest ? 'lg' : 'md')]: {
            fontSize:
                theme.kind === Product.TheWest ? calcRem(16) : calcRem(14),
            lineHeight:
                theme.kind === Product.TheWest ? calcRem(20) : calcRem(17),
        },
    }),
)

export const StyledEpaperCollectionPapersStyledImg = styled('img')(
    ({ theme }) => ({
        width: '190px',
        height: '270px',
        objectFit: 'cover',
        filter: theme.kind === Product.TheWest ? 'brightness(0.93)' : undefined,
        [breakpoint(theme.kind === Product.TheWest ? 'lg' : 'md')]: {
            maxWidth: '100%',
            height: theme.kind === 'thewest' ? '233px' : '194px',
        },
    }),
)

export const StyledIconPremium = styled(IconPremium)(({ theme }) => ({
    width: calcRem(25),
    height: 'auto',
    verticalAlign: 'text-bottom',
    marginRight: calcRem(1),
    paddingTop: calcRem(4),
    flexShrink: 0,
    [breakpoint('lg')]: {
        width: themedValue(theme, {
            thewest: calcRem(20),
            perthnow: calcRem(18),
            fallback: undefined,
        }),
        marginTop: calcRem(1),
        paddingTop: 0,
    },
}))

export const StyledDate = styled('div')(({ theme }) => ({
    [breakpoint(theme.kind === Product.TheWest ? 'lg' : 'md')]: {
        display: 'flex',
        flexFlow: 'column',
    },
}))

export const StyledDateSpan = styled('span')(({ theme }) => ({
    [breakpoint(theme.kind === Product.TheWest ? 'lg' : 'md')]: {
        width: '100%',
    },
}))
